module.exports = __webpack_public_path__ + "img/30_50.20067116.png";